<div class="p-3 tasks" *ngIf="tasks">
  <ng-container *ngFor="let task of tasks">
    <div *ngIf="task.alertVisibleViews.includes(selectedViewType) && !isTaskHidden(task)"
      [ngStyle]="{ 'background-color': task.colour }"
      class="cursor-pointer flex justify-left rounded p-2 m-2"
      (click)="openSidePanel(task.name)"
    >
      <img [src]="task.imageSrc" />
      <div class="pl-3">{{ getCount(task.name) }}</div>
      <div class="pl-3">{{ task.name }}</div>
    </div>
  </ng-container>
</div>